import { Checkbox, DefaultButton, Dialog, DialogFooter, DialogType, IDialogStyleProps, IDialogStyles, IStyleFunctionOrObject, Link, PrimaryButton, classNamesFunction } from "@fluentui/react"
import { RouteComponentProps, withRouter } from "react-router";
import { InjectedIntlProps, injectIntl } from "react-intl";
import { messages } from "./Announcements.messages";
import { getStyles } from "./Announcements.styles";
import { useSelector } from "react-redux";
import { getCurrentTheme } from "../../../core/store";
import NoDataImage from "../../images/noDataImage.svg";
import lightThemeBackground from "../../images/modal_Background_Light.png";
import darkThemeBackground from "../../images/modal_Background_dark.png";
import { useCallback, useEffect, useState } from "react";
import { appConfig } from "../../App.config";
import ReactHtmlParser from 'react-html-parser';
import { AnnouncementLSKey } from "./Announcements.type";
import useCustomLogService from '../../services/useCustomLogService';

interface OwnProps extends InjectedIntlProps {
  filteredAnnouncements: any;
  hideDialog: boolean;
  toggleHideDialog: (dontShowAgain: boolean) => void;
  openedThroughMenu: boolean;
  title: string,
  subText: string
  triggerTeachingBubble: () => void;
}
type Props = OwnProps & RouteComponentProps


const getClassNames = classNamesFunction<any, any>();
let classes: any;

const WhatsNewComponent: React.FC<Props> = ({ intl, filteredAnnouncements, hideDialog, toggleHideDialog, openedThroughMenu, title, subText, triggerTeachingBubble }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const theme = useSelector(getCurrentTheme);
  classes = getClassNames(getStyles, theme);

  const { trackCustomEvents } = useCustomLogService();

  const trackWhatsNewClicks = useCallback((name: string) => {
      trackCustomEvents(`ECIFWorkscopePortal.WhatsNew`,  `${name} Button Clicked`, 'Success');
  }, [trackCustomEvents]);

  const dialogContentProps = {
    type: DialogType.normal,
    closeButtonAriaLabel: 'Close',
    className: classes.dialogContent
  };


  const modalProps = {
    isBlocking: true,
    className: classes.modalContainer
  }
  const [imageError, setImageError] = useState(false);
  // const [imageUrl, setImageUrl] = useState('');
  // const [backgroundImageUrl, setBackgroundImageUrl] = useState('');

  useEffect(() => {
    trackCustomEvents('ECIWorkscopePortal.WhatsNew',  'Whats new popup opened', 'Success');

    return () => {
      trackCustomEvents('ECIWorkscopePortal.WhatsNew',  'Whats new popup closed', 'Success');
    }
  }, []);

  // useEffect(() => {
  //   const tempUrl = appConfig.isLocalAnnouncement
  //     ? `/data/announcement/${filteredAnnouncements[currentIndex]?.imageName}`
  //     : `${process.env.REACT_APP_ANNOUNCEMENT_CDN_IMAGE_FOLDER_URL}${filteredAnnouncements[currentIndex]?.imageName}?${process.env.REACT_APP_CDN_TOKEN}`;
  //   setImageUrl(tempUrl);

  //   const tempBackgroundImageUrl = theme.name === 'default' ? lightThemeBackground : darkThemeBackground;
  //   // setBackgroundImageUrl(tempBackgroundImageUrl);
  // }, [currentIndex, theme, filteredAnnouncements]);

  // Add image preloading
  useEffect(() => {
    // Preload all images when component mounts
    const preloadImages = () => {
      const imageRefs = [];
      filteredAnnouncements.forEach((announcement) => {
        if (announcement.imageName) {
          const img = new Image();
          img.src = `/data/announcement/${announcement.imageName}`;
          // store in variable to prevent garbage collection
          imageRefs.push(img);
        }
      });
    };

    if (filteredAnnouncements && filteredAnnouncements.length > 0) {
      preloadImages();
    }
  }, [filteredAnnouncements?.length]);

  const handleImageError = () => {
    setImageError(true);
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      trackWhatsNewClicks(intl.formatMessage(messages.previous));
    }
  };

  const handleNextClick = () => {
    if (currentIndex < filteredAnnouncements.length - 1) {
      setCurrentIndex(currentIndex + 1);
      trackWhatsNewClicks(intl.formatMessage(messages.next));
    }
  };

  const [dontShowAgain, setDontShowAgain] = useState(false);

  const triggerTeachingBubbleAfterWhatsNew = (action: string) => {
    triggerTeachingBubble();
    trackCustomEvents(`ECIFWorkscopePortal.WhatsNew.TeachingBubble`,  `Started teaching bubble after ${action}`, 'Success');
  }

  const handleOnFinishClicked = (ev: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    const showTour = localStorage.getItem(AnnouncementLSKey.ANNOUNCEMENT_POPUP_STATE) === null;
    showTour && triggerTeachingBubbleAfterWhatsNew(intl.formatMessage(messages.finishButton));
    setDontShowAgain(true);
    toggleHideDialog(true);
    localStorage.setItem(AnnouncementLSKey.ANNOUNCEMENT_POPUP_STATE, AnnouncementLSKey.FINISH);
    trackWhatsNewClicks(intl.formatMessage(messages.finishButton));
  }

  function toggleHide(event: any, action: string): void {
    trackWhatsNewClicks(action);

    const isFirstTimeUser = localStorage.getItem(AnnouncementLSKey.ANNOUNCEMENT_POPUP_STATE);
    if (isFirstTimeUser === null) {
      localStorage.setItem(AnnouncementLSKey.ANNOUNCEMENT_POPUP_STATE, AnnouncementLSKey.NOT_NOW);
      triggerTeachingBubbleAfterWhatsNew(action);
      toggleHideDialog(false);
      return;
    }
    toggleHideDialog(false);
  }

  return (
    <Dialog
      minWidth={980}
      maxWidth={1100}

      hidden={hideDialog}
      onDismiss={(e) => {
        toggleHide(e, 'close');
      }}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      styles={{ main:{ width: '980px !important'}}} // Due to copilot version update some Css is overriding the width. So to fix it added this line.

    >
      {!!filteredAnnouncements.length ? (
        <div>
          <div className={classes.announcementContentContainer}>
            {!imageError && filteredAnnouncements[currentIndex].imageName && (
              <div className={classes.imageContainerDiv}>
                <img
                  src={`/data/announcement/${filteredAnnouncements[currentIndex]?.imageName}`}
                  className={classes.imageContainer}
                  alt={`${title}`}
                  onError={handleImageError}
                />
              </div>
            )}
            <div className={classes.bodyDescriptionStyles}>
              <h3 className={classes.subText}>{filteredAnnouncements[currentIndex]?.announcementTitle ? filteredAnnouncements[currentIndex]?.announcementTitle : subText}</h3>
              {filteredAnnouncements[currentIndex].announcementDescription.map(
                (item, index) => (
                  <div className={classes.subHeadingContainer} key={index}>
                    <h4 className={classes.subheading} id={intl.formatMessage(messages.announcementsSubHeadingId)}>{ReactHtmlParser(item.subheading)}</h4>
                    <div className={classes.descriptionContainer}>
                      <p className={classes.description}>
                        {ReactHtmlParser(item.description)}
                      </p>
                      {!!item.bulletPoints.length && (
                        <ul className={classes.bulletPoints}>
                          {item.bulletPoints.map((bullet, bulletIndex) => (
                            <li key={bulletIndex}>{ReactHtmlParser(bullet)}</li>
                          ))}
                        </ul>
                      )}
                      {item.wikiLink && (
                        <Link href={item.wikiLink} target="_blank" className={classes.knowMoreLink}>
                          {intl.formatMessage(messages.knowMoreLink)}
                        </Link>
                      )}
                      {item.videoLink && (
                        <Link href={item.videoLink} target="_blank" className={classes.knowMoreLink}>
                          {intl.formatMessage(messages.videoLink)}
                        </Link>
                      )}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>
          <img src={NoDataImage} alt={intl.formatMessage(messages.noNewAnnouncements)} />
        </div>
      )}
      <DialogFooter
        className={classes.dialogFooter}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className={classes.stepper}>
            {filteredAnnouncements.length > 1 && filteredAnnouncements.map((announcement, index) => (
              <div
                key={index}
                className={`${classes.step} ${currentIndex === index ? classes.activeStep : ''}`}
              />
            ))}
          </div>
          <div className={classes.footerButtonContainer}>
            {currentIndex === 0 ? (
              <DefaultButton
                text={intl.formatMessage(messages.notNowButton)}
                onClick={(e) => {
                  toggleHide(e, intl.formatMessage(messages.notNowButton));
                }}
                style={{ marginRight: '10px' }}
              />
            ) : (
              <DefaultButton
                text={intl.formatMessage(messages.previous)}
                onClick={handlePrevClick}
                disabled={currentIndex === 0}
                style={{ marginRight: '10px' }}
              />
            )}
            {currentIndex === filteredAnnouncements.length - 1 ? (
              <PrimaryButton
                text={intl.formatMessage(messages.finishButton)}
                onClick={handleOnFinishClicked}
                style={{ marginRight: '10px' }}
              />
            ) : (
              <PrimaryButton
                text={intl.formatMessage(messages.next)}
                onClick={handleNextClick}
                disabled={currentIndex === filteredAnnouncements.length - 1}
                style={{ marginRight: '10px' }}
              />
            )}
          </div>
        </div>
      </DialogFooter>
    </Dialog>
  );
}

export const WhatsNew = withRouter(injectIntl(WhatsNewComponent));